import script from "./AllPayments.vue?vue&type=script&setup=true&lang=js"
export * from "./AllPayments.vue?vue&type=script&setup=true&lang=js"

import "./AllPayments.vue?vue&type=style&index=0&id=79c52ecc&lang=css"

const __exports__ = script;

export default __exports__